import { styled } from "@mui/material/styles";
import Slider from "components/elements/Slider";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { getColorByMode } from "utils";

export const TargetSlider = styled(Slider)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    color: theme.palette.primary.main,
    cursor: "default",
    maxWidth: "70%",
    height: 8,
    "& .MuiSlider-rail": {
      backgroundColor: getColorByMode(theme, colors.gray200, colors.gray400),
    },
    "& .MuiSlider-track": {
      border: "none",
      borderRadius: "4px 0 0 4px",
    },
    "& .MuiSlider-thumb": {
      height: 8,
      width: 8,
      backgroundColor: colors.white,
      border: "2px solid currentColor",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      backgroundColor: "#101828",
      borderRadius: "10px",
      padding: "8px 12px",
      fontWeight: 600,
      fontSize: "12px",
    },
    "& .MuiSlider-markLabel": {
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.005em",
      color: colors.black,
      transform: "translateX(-50%) rotate(-30deg)",
      transformOrigin: "top center",
      whiteSpace: "nowrap",
    },
  };
});
